"use client";

import Image from "next/image";
import Link from "next/link";
import logoWhiteNoBg from "@/assets/imgs/logo-white-no-bg.png";
import { routes } from "@/lib/utils/routes";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TwitterIcon,
} from "@/modules/components/commons/icon/SocialIcons";
import { useClientTranslations } from "@/lib/translate";

const PublicFooter = () => {
  const { t } = useClientTranslations("footer-public");

  return (
    <footer className="bg-primaryDark text-white">
      <div className="container mx-auto px-2 md:px-8 pt-12 pb-5">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <Image
              src={logoWhiteNoBg}
              width={455}
              height={144}
              alt={t("title")}
              className="w-32"
            />
            <p className="text-gray-300 mt-4">{t("subtitle")}</p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="hover:text-secondary transition-colors duration-300"
              >
                <FacebookIcon />
              </a>
              <a
                href="#"
                className="hover:text-secondary transition-colors duration-300"
              >
                <TwitterIcon />
              </a>
              <a
                href="#"
                className="hover:text-secondary transition-colors duration-300"
              >
                <LinkedinIcon />
              </a>
              <a
                href="#"
                className="hover:text-secondary transition-colors duration-300"
              >
                <InstagramIcon />
              </a>
            </div>
          </div>

          {/* For Job Seekers */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              {t("forCandidate.title")}
            </h3>
            <ul className="space-y-2 ps-5">
              <li>
                <Link
                  href={routes.job.index}
                  className="text-gray-300 hover:text-white transition-colors duration-300"
                >
                  {t("forCandidate.findJob")}
                </Link>
              </li>
              <li>
                <Link
                  href={routes.job.category}
                  className="text-gray-300 hover:text-white transition-colors duration-300"
                >
                  {t("forCandidate.category")}
                </Link>
              </li>
              <li>
                <Link
                  href="/referral-cv"
                  className="text-gray-300 hover:text-white transition-colors duration-300"
                >
                  {t("forCandidate.referCV")}
                </Link>
              </li>
            </ul>
          </div>

          {/* For Employers */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              {t("forEmployer.title")}
            </h3>
            <ul className="space-y-2 ps-5">
              <li>
                <Link
                  href={routes.company.index}
                  className="text-gray-300 hover:text-white transition-colors duration-300"
                >
                  {t("forEmployer.postJob")}
                </Link>
              </li>
              <li>
                <Link
                  href="/contact-interviewer"
                  className="text-gray-300 hover:text-white transition-colors duration-300"
                >
                  {t("forEmployer.contactInterviewer")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t("contact.title")}</h3>
            <ul className="space-y-2 ps-5">
              <li className="text-gray-300">
                <strong>{t("contact.address")}:</strong> 123 Đường ABC, Quận 1,
                TP.HCM
              </li>
              <li className="text-gray-300">
                <strong>{t("contact.email")}:</strong>{" "}
                <a
                  href="mailto:support@togetherwork.online"
                  className="hover:text-white transition-colors duration-300"
                >
                  support@togetherwork.online
                </a>
              </li>
              <li className="text-gray-300">
                <strong>{t("contact.phone")}:</strong>{" "}
                <a
                  href="tel:1900123456"
                  className="hover:text-white transition-colors duration-300"
                >
                  1900 123 456
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-5 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">{t("copyright.title")}</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link
                href="/privacy-policy"
                className="text-gray-300 hover:text-white text-sm transition-colors duration-300"
              >
                {t("terms")}
              </Link>
              <Link
                href="/terms-of-service"
                className="text-gray-300 hover:text-white text-sm transition-colors duration-300"
              >
                {t("privacy")}
              </Link>
              {/* <Link
                href="/sitemap"
                className="text-gray-300 hover:text-white text-sm transition-colors duration-300"
              >
                Sitemap
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

PublicFooter.displayName = "PublicFooter";
export default PublicFooter;
